// Session and sign-in endpoints (owner account-settings in wave 2). Typed contract calls
// (`@dataroom/contracts/account`); new account endpoints are called with `api.call(contract)`.
import type { UpdateMemberPreferencesInput } from '@dataroom/core';
import {
  devLogin,
  getMe,
  listDevUsers,
  logout,
  updateMyPreferences,
} from '@dataroom/contracts/account/session';
import type { Http } from './http';
import { createCall } from './typed';

export const authApi = (http: Http) => {
  const call = createCall(http);
  return {
    devUsers: () => call(listDevUsers),
    devLogin: (email: string) => call(devLogin, { body: { email } }),
    logout: () => call(logout),
    me: () => call(getMe),
    /** Your own preferences; null follows the workspace default. */
    updatePreferences: (input: UpdateMemberPreferencesInput) => call(updateMyPreferences, { body: input }),
  };
};
